import React from 'react';

import { Link } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import MenuIcon from '@material-ui/icons/Menu';
import ListIcon from '@material-ui/icons/List';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

class MenuBar extends React.Component {
	state = {
		mainMenuOpen: false,
		mainAnchorEl: null
	};

	handleMainMenu = event => {
		this.setState({ mainAnchorEl: event.currentTarget });
	};

	handleClose = () => {
		this.setState({ mainAnchorEl: null });
	}

	render() {
		const { mainAnchorEl } = this.state;

		return (
			<AppBar position="static">
				<Toolbar>
					<div>
						<IconButton onClick={this.handleMainMenu} style={{marginLeft: -12, marginRight: 20}} color="inherit">
							<MenuIcon />
						</IconButton>
						<Menu
							id="menu-main"
							anchorEl={mainAnchorEl}
							anchorOrigin={{vertical: 'top', horizontal: 'right'}}
							transformOrigin={{vertical: 'top', horizontal: 'right'}}
							open={!!mainAnchorEl}
							onClose={this.handleClose}
							onClick={this.handleClose}
							PaperProps={{style: { width: 200 }}}>
							<MenuItem component={Link} to="/">
								<ListItemIcon>
									<AssignmentIcon />
								</ListItemIcon>
								<ListItemText inset primary="Service" />
							</MenuItem>
							<MenuItem component={Link} to="/calendar">
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText inset primary="Calendar" />
							</MenuItem>
							<hr />
							<MenuItem component={Link} to="/login">
								<ListItemIcon>
									<ExitToAppIcon />
								</ListItemIcon>
								<ListItemText inset primary="Logout" />
							</MenuItem>
						</Menu>
					</div>
					<Typography variant="title" color="inherit">foperator</Typography>
				</Toolbar>
			</AppBar>
		);
	}
}

export default MenuBar;



// WEBPACK FOOTER //
// ./src/components/MenuBar.js